import { Col, Empty, Row, Spin } from "antd";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import FileCard from "../../../components/FileCard";
import { getEncFileKeys, loadMoreFiles } from "../../../redux/action/file";
import EmptyFolder from "../../../components/EmptyFolder";
import { useTranslation } from "react-i18next";

const SubFile = () => {
  let { t } = useTranslation();

  const { sub_files, pagination_data } = useSelector(
    (state) => state.fileSlice
  );
  const [loading, setLoading] = useState(false);
  const observerRef = useRef();

  useEffect(() => {
    getEncFileKeys();
  }, []);

  // Function to load more files
  const handleLoadMore = useCallback(async () => {
    if (loading || !pagination_data?.hasNextPage) return;

    setLoading(true);

    try {
      // Get directory info from localStorage
      const fileDirectory = JSON.parse(localStorage.getItem("fileDirectory"));
      const { path, directory } = fileDirectory || {};

      if (path && directory) {
        await loadMoreFiles(path, directory, pagination_data.nextPage);
      }
    } catch (error) {
      console.error("Error loading more files:", error);
    } finally {
      setLoading(false);
    }
  }, [loading, pagination_data]);

  // Intersection Observer for infinite scroll
  const lastFileElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && pagination_data?.hasNextPage) {
          handleLoadMore();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [loading, handleLoadMore, pagination_data]
  );

  return (
    <div>
      {sub_files?.length ? (
        <Row gutter={[16, 16]}>
          {sub_files.map((file, index) => {
            const isLast = index === sub_files.length - 1;
            return (
              <Col
                key={`${file.fileId}-${index}`}
                xs={12}
                sm={8}
                md={6}
                lg={4}
                xl={4}
                xxl={3}
              >
                <div ref={isLast ? lastFileElementRef : null}>
                  <FileCard
                    name={file.name}
                    isSub
                    {...file}
                    icon={false}
                    directory={file.directory || ""}
                    thumbnailUrl={file.thumbnailUrl}
                    actualImage={file.originalUrl}
                    ext={file.originalFileExt}
                    isHeader
                    fileId={file.fileId}
                    fileSize={file.size}
                    fileDate={file.createdAt}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      ) : (
        <EmptyFolder
          title={`${t("messages.folderEmptyTitle")}`}
          subTitle={`${t("messages.folderEmptySubtitle")}`}
        />
      )}

      {loading && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Spin size="large" />
        </div>
      )}

      {/* {!loading &&
        pagination_data &&
        !pagination_data.hasNextPage &&
        sub_files?.length > 0 && (
          <div style={{ textAlign: "center", marginTop: 20, color: "#999" }}>
            No more files to load
          </div>
        )} */}
    </div>
  );
};

export default SubFile;
